import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import styled from "styled-components";
import Button from "@mui/material/Button";
import { gql } from "@apollo/client";
import { client } from "../../../client";
import { uploadFileWithPresignedUrl } from "../../../utils/s3Uploader";

import FileUploader from "../admin-document/FileUploader";

const ModalContainer = styled(Box)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
  background-color: white; /* Change to white background */
  padding: 20px;
  z-index: 100;
  border: 1px solid #ccc; /* Add a subtle border */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Add a subtle box shadow */
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center; /* Center-align all children */
  margin-top: 30px;
  margin-bottom: 30px;
`;

const UserInfoItem = styled.div`
  display: flex; /* Display children in a row */
  flex-direction: row;
  margin-bottom: 10px; /* Add margin between child components */
`;

const NoticeText = styled.textarea`
  width: 200px;
  height: 150px;
`;

const ModifyFaqAdmin = ({
  isOpen,
  data,
  handleCloseClick,
  refetchParentData,
  children,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const enumType = {
    DOWNLOAD: "DOWNLOAD",
    PAYMENT: "PAYMENT",
    ACCOUNT: "ACCOUNT",
    ETC: "ETC",
  };

  Object.freeze(enumType);

  const [editableData, setEditableData] = useState({});
  useEffect(() => {
    setEditableData({
      id: data?.id,
      visible: data?.visible,
      type: data?.type,
      title: data?.title,
      content: data?.content,
      object_url: data?.object_url,
    });
  }, [data]);

  const handleInputChange = (key, value) => {
    if (key === "visible") {
      console.log("확인 : ", value);
      let booleanValue = value === "1";
      setEditableData((prevData) => ({
        ...prevData,
        [key]: booleanValue,
      }));
    } else if (key === "id") {
      let intValue = parseInt(value, 10);
      setEditableData((prevData) => ({
        ...prevData,
        [key]: intValue,
      }));
    } else if (key === "type") {
      let typeValue;
      switch (value) {
        case "ACCOUNT":
          typeValue = enumType.ACCOUNT;
          break;
        case "DOWNLOAD":
          typeValue = enumType.DOWNLOAD;
          break;
        case "PAYMENT":
          typeValue = enumType.PAYMENT;
          break;
        case "ETC":
        default:
          typeValue = enumType.ETC;
          break;
      }
      console.log("enum 확인 :", typeValue);

      setEditableData((prevData) => ({
        ...prevData,
        [key]: typeValue,
      }));
    } else {
      setEditableData((prevData) => ({
        ...prevData,
        [key]: value,
      }));
    }
  };

  useEffect(() => {
    console.log("enum 확인2 :", editableData.type);
  }, [editableData.type]);

  const handleModifyClick = (objectUrl) => {
    const MODIFY_FAQ_ADMIN = gql`
      mutation modifyFaqByAdmin(
        $id: Int
        $visible: Boolean
        $type: faqTypeEnum
        $title: String
        $content: String
        $object_url: String
      ) {
        modifyFaqByAdmin(
          id: $id
          visible: $visible
          type: $type
          title: $title
          content: $content
          object_url: $object_url
        ) {
          message
        }
      }
    `;

    client
      .mutate({
        mutation: MODIFY_FAQ_ADMIN,
        variables: {
          ...editableData,
          object_url: objectUrl,
        },
      })
      .then((res) => {
        console.log("update");
        console.log(res);
        console.log("enum 확인3 :", editableData.type);
        refetchParentData();
        handleCloseClick();
      })
      .catch((err) => {
        console.error(err);
        alert(`수정 중 오류가 발생했습니다: ${err.message}`);
      });
  };

  const handleUploadAndModify = async () => {
    setIsLoading(true);
    try {
      let finalObjectUrl = editableData.object_url;

      if (selectedFile) {
        finalObjectUrl = await uploadFileWithPresignedUrl(client, selectedFile);
        handleInputChange("object_url", finalObjectUrl);
      }

      handleModifyClick(finalObjectUrl);
    } catch (err) {
      alert(`업로드 중 오류가 발생했습니다: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const updatedTime = (params) => {
    const date = new Date(parseInt(params));
    return date.toLocaleString("ko-kr");
  };

  // 이미지 URL을 제거하는 함수
  const handleRemoveImage = () => {
    // 사용자에게 한번 더 확인 받기
    if (window.confirm("첨부된 이미지를 제거하시겠습니까?")) {
      handleInputChange("object_url", null);
      // editableData.object_url이 null로 설정되었음을 사용자에게 시각적으로 보여주기 위해
      // alert("이미지가 제거되었습니다. '수정' 버튼을 눌러 최종 저장해주세요.");
    }
  };

  if (!isOpen) return null;

  return (
    <ModalContainer>
      <h2> FAQ 수정 </h2>

      <UserInfoContainer>
        {Object.keys(data).map((key) => {
          if (key === "__typename") return null;
          return (
            <div key={key}>
              {key === "title" ||
              key === "content" ||
              key === "object_url" ||
              key === "type" ||
              key === "created_at" ||
              key === "updated_at" ||
              key === "visible" ? (
                <UserInfoItem>
                  <div>
                    <Box mr={"5px"}>{key}: </Box>
                  </div>
                  <div>
                    {key === "visible" ? (
                      <select
                        value={editableData[key] ? "1" : "0"}
                        onChange={(e) => handleInputChange(key, e.target.value)}
                      >
                        <option value={1}>노출</option>
                        <option value={0}>비노출</option>
                      </select>
                    ) : key === "updated_at" || key === "created_at" ? (
                      <Box>{updatedTime(data[key])}</Box>
                    ) : key === "object_url" ? (
                      <div>
                        {/* 현재 이미지 URL이 있을 경우에만 이미지와 제거 버튼 표시 */}
                        {editableData.object_url ? (
                          <>
                            <Box
                              display={"flex"}
                              ml={"10px"}
                              maxHeight={"150px"}
                              maxWidth={"150px"}
                            >
                              <img
                                src={editableData.object_url}
                                alt="FAQ 첨부 이미지"
                              />
                            </Box>
                            <Button
                              size="small"
                              color="error"
                              onClick={handleRemoveImage}
                              style={{ marginLeft: "10px" }}
                            >
                              이미지 제거
                            </Button>
                          </>
                        ) : (
                          <Box ml={"10px"}>
                            <p>첨부된 이미지가 없습니다.</p>
                          </Box>
                        )}
                        <UserInfoItem>
                          <FileUploader
                            selectedFiles={selectedFile ? [selectedFile] : []}
                            setSelectedFiles={(files) =>
                              setSelectedFile(files[0] || null)
                            }
                          />
                        </UserInfoItem>
                      </div>
                    ) : key === "content" ? (
                      <Box>
                        <NoticeText
                          type="text"
                          value={editableData[key]}
                          onChange={(e) =>
                            handleInputChange(key, e.target.value)
                          }
                        />
                      </Box>
                    ) : key === "type" ? (
                      <select
                        value={editableData[key]}
                        onChange={(e) => handleInputChange(key, e.target.value)}
                      >
                        <option value="ACCOUNT">계정</option>
                        <option value="DOWNLOAD">다운로드</option>
                        <option value="PAYMENT">결제</option>
                        <option value="ETC">기타</option>
                      </select>
                    ) : (
                      <input
                        type="text"
                        value={editableData[key] || ""}
                        onChange={(e) => handleInputChange(key, e.target.value)}
                      />
                    )}
                  </div>
                </UserInfoItem>
              ) : (
                <UserInfoItem>
                  {key} : {data[key]}
                </UserInfoItem>
              )}
            </div>
          );
        })}
      </UserInfoContainer>

      <Button
        variant="contained"
        onClick={handleUploadAndModify}
        disabled={isLoading}
      >
        {isLoading ? "수정 중..." : "수정"}
      </Button>

      <Button onClick={() => handleCloseClick()}> 닫기 </Button>
    </ModalContainer>
  );
};

export default ModifyFaqAdmin;
